import { configureStore } from "@reduxjs/toolkit";
import arcadeReducer from "./slices/arcadeSlice";

export const store = configureStore({
  reducer: {
    arcade: arcadeReducer,
  },
});
